import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Transaction } from '../../../../../models/entities/transactions/transaction';

@Component({
    selector: 'app-journal-entry-details',
    templateUrl: './journal-entry-details.component.html',
    styleUrls: ['./journal-entry-details.component.scss'],
})
export class JournalEntryDetailsComponent implements OnChanges
{
    @Input() transaction: Transaction;
    debitEntries: any[] = [];
    creditEntries: any[] = [];

    ngOnChanges(changes: SimpleChanges) {
        if (this.hasOwnProperty('transaction') && this.transaction.journalEntries) {
            this.debitEntries = this.transaction.journalEntries.filter((je) => je.type === 'debit');
            this.creditEntries = this.transaction.journalEntries.filter((je) => je.type === 'credit');
        }
    }
}
